<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col w-full h-full">
      <two-blocks-layout :navigate="navigate" v-bind="page" class="my-auto">
        <span class="text-outline text-title-md" v-text="`${page.titolo1} `" />
        <span class="text-title-md" v-text="`${page.titolo2}`" />

        <template #right
          ><calcolatore-vincolato v-bind="calc" v-if="calc" />
        </template>
      </two-blocks-layout>
    </div>
  </div>
</template>

<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";
import CalcolatoreVincolato from "@/components/vincolato/CalcolatoreVincolato";
export default {
  components: { TwoBlocksLayout, CalcolatoreVincolato },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page = Object();
    let calc = Object();
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
      calc = await axios.get(`${process.env.VUE_APP_SITECORE_VINCOLATO_API}`);
    } catch (error) {
      let page = page || Object();
      let calc = calc || Object();
    } finally {
      next(vm => {
        (vm.page = page.data || Object()), (vm.calc = calc.data || Object());
      });
    }
  }
};
</script>

<route>
{
  "name": "Vincoli",
  "meta": {
      "order": 4,
      "label": "Depositi"
  }
}
</route>
